import { render, staticRenderFns } from "./PageTypeRadioOption.vue?vue&type=template&id=4193b5c3&"
import script from "./PageTypeRadioOption.vue?vue&type=script&lang=js&"
export * from "./PageTypeRadioOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports